import {Component} from 'react'
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types'

import ChevronLeft from 'react-feather/dist/icons/chevron-left.js'
import ChevronRight from 'react-feather/dist/icons/chevron-right.js'

export default class Pagination extends Component {
  static propTypes = {
    current: PropTypes.number.isRequired,
    generateLink: PropTypes.func.isRequired,
    pagesCount: PropTypes.number.isRequired,
    className: PropTypes.string,
  }

  static defaultProps = {
    className: ''
  }

  // A disabled item must not render a link: its target would be out of range
  // (e.g. page 0 before the first page), and crawlers or keyboard users still follow it.
  renderItem(page, enabled, content, className = 'page-link d-flex align-items-center h-100') {
    return (
      <li className={`page-item ${!enabled ? 'disabled' : ''}`}>
        {enabled ? (
          <Link to={this.props.generateLink(page)} className={className}>{content}</Link>
        ) : (
          <span className={className}>{content}</span>
        )}
      </li>
    )
  }

  render() {
    const {current, pagesCount} = this.props
    if (pagesCount <= 1) {
      return null
    }

    const hasPrevious = (current > 0)
    const hasNext = (current < pagesCount - 1)

    return (
      <nav aria-label="Pagination" className={this.props.className}>
        <ul className="pagination">
          {this.renderItem(0, hasPrevious, <><ChevronLeft size={20}/><ChevronLeft size={20}/></>)}
          {this.renderItem(current - 1, hasPrevious, <ChevronLeft size={20}/>)}
          <li className="page-item">
            <span className="page-link">{current + 1}</span>
          </li>
          {this.renderItem(current + 1, hasNext, <ChevronRight size={20}/>)}
          {this.renderItem(pagesCount - 1, hasNext, <><ChevronRight size={20}/><ChevronRight size={20}/></>)}
        </ul>
      </nav>
    )
  }
}
